import React from 'react';
import '../CLD/Candlelight.css'
import festivalDecorationsData from './FDdata.js';
import { useCart } from '../Cart/Cart'; 
import { useState, useEffect } from 'react';
import SubCardDetail from '../Occasions/SubCardDetail';
import { toast } from 'react-toastify';

function FestivalDecorations() {
  const { addToCart } = useCart();
  const [selectedBooking, setSelectedBooking] = useState(null);

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 if (selectedBooking){
  return(
    <SubCardDetail
    card={selectedBooking}
    onBack={() => setSelectedBooking(null)}
    />
  )
}
  const renderStars = (rating) => {
    const fullStars = '⭐'.repeat(rating);
    const emptyStars = '☆'.repeat(5 - rating);
    return fullStars + emptyStars;
  };

  return (
    <div>
      <h2 className="title">Best Festival and Pooja Decorations Online</h2>
      <div className="card-container">

        {festivalDecorationsData.map((item, idx) => (

          <div 
  className="card" 
  key={idx}
  onClick={() => setSelectedBooking(item)}
  style={{ cursor: "pointer" }}
>
  <img src={item.image} alt={item.title} />
  <div className="card-content">
    <p className="card-title">{item.title}</p>
    <p className="price">₹{item.price.toLocaleString()}</p>
    <div className="stars">{renderStars(item.rating)}</div>
    <button
      className="add-to-cart-btn"
      onClick={(e) => {
        e.stopPropagation(); 
        addToCart({ ...item, quantity: 1 });
        toast.success('Item added to your cart!');
        
      }}
    >
      Add to Cart
    </button>
  </div>
</div>
        ))}
         </div>
    </div>
  );
}

export default FestivalDecorations;
